// Retourne l'année scolaire en cours (ex: si on est en mai 2026 → 2025)
export function getAnneeScolaireEnCours() {
  const now = new Date()
  const mois = now.getMonth() + 1 // 1-12
  const annee = now.getFullYear()
  // Septembre (9) = début nouvelle année scolaire
  return mois >= 9 ? annee : annee - 1
}

// Label affiché : "2025-2026"
export function labelAnneeScolaire(anneeDebut) {
  return `${anneeDebut}-${anneeDebut + 1}`
}

// Dates de début et fin d'une année scolaire
export function plageAnneeScolaire(anneeDebut) {
  return {
    debut: `${anneeDebut}-09-01`,
    fin: `${anneeDebut + 1}-08-31`,
  }
}

// Liste des années scolaires disponibles
export function listeAnneesScolaires() {
  const current = getAnneeScolaireEnCours()
  return [current - 2, current - 1, current, current + 1]
}
